import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../../Redux/actions/userActions.js";
import Loading from "../../components/Loading.jsx";
import Error from "../../components/Error.jsx";
import { showToast } from "../../components/ToastMessage.jsx";
import { useSanitizedInput } from "../../hooks/useSanitizedInput.js";
import "./AuthScreens.css";

const ResetPasswordScreen = () => {
  const { token } = useParams();
  // ✅ Correct destructuring
  const [password, handlePasswordChange] = useSanitizedInput("", "text");
  const [confirmPassword, handleConfirmPasswordChange] = useSanitizedInput("", "text");
  const [successMsg, setSuccessMsg] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);

  const submitHandler = async (e) => {
    e.preventDefault();

    // ✅ Validate
    if (password.length < 6) {
      showToast("Password must be at least 6 characters", "error");
      return;
    }
    
    if (password !== confirmPassword) {
      showToast("Passwords do not match", "error");
      return;
    }

    setButtonDisabled(true);
    setSuccessMsg("");

    try {
      await dispatch(resetPassword(token, password, confirmPassword));
      setSuccessMsg("✅ Password reset successful!");
      showToast("Password reset successful!");

      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      showToast(err.response?.data?.msg || "Reset failed", "error");
    } finally {
      setButtonDisabled(false);
    }
  };

  return (
    <div className="auth-bg d-flex align-items-center justify-content-center">
      <div className="auth-card shadow-lg p-4 rounded-4">
        <h2 className="text-center mb-4 fw-bold text-teal">Reset Password</h2>
        <p className="text-center text-muted mb-4">
          Enter your new password below.
        </p>

        {error && <Error message={error} />}
        {loading && <Loading />}
        {successMsg && <div className="alert alert-success">{successMsg}</div>}

        <form onSubmit={submitHandler}>
          <div className="mb-3">
            <label className="fw-semibold">New Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Minimum 6 characters"
              value={password}
              onChange={handlePasswordChange}
              maxLength="128"
              minLength="6"
              required
              disabled={loading || buttonDisabled}
            />
          </div>
          
          <div className="mb-3">
            <label className="fw-semibold">Confirm New Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Re-enter password"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              maxLength="128"
              minLength="6"
              required
              disabled={loading || buttonDisabled}
            />
          </div>
          
          <button
            type="submit"
            className="btn btn-teal w-100 mb-3"
            disabled={buttonDisabled || loading}
          >
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordScreen;